import { transformSharePermissionsToServer } from '@atlassian/jira-common-directory-v2/src/services/transformers.tsx';
import type { OperationData } from '@atlassian/jira-shareable-entity-dialog/src/model/types.tsx';
import type { CopyFilterRequestBody } from '../types.tsx';

export const transformCopyFilter = (
	filter: OperationData,
	jql: string,
	isFavourite: boolean,
): CopyFilterRequestBody => {
	const { description, name, owner, editPermissions, sharePermissions } = filter;
	const result: CopyFilterRequestBody = {
		name,
		description,
		favourite: isFavourite,
		jql,
		sharePermissions: transformSharePermissionsToServer(sharePermissions || [], true),
		editPermissions: transformSharePermissionsToServer(editPermissions || [], true),
	};

	if (owner) {
		result.owner = {
			accountId: owner.accountId,
		};
	}

	return result;
};
